// extracted by mini-css-extract-plugin
export default {"button":"EditNoteButton_button__eGe3c"};